import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "attachment-box" }
const _hoisted_2 = { class: "attachment-info" }
const _hoisted_3 = {
  role: "button",
  class: "attachment-name",
  style: {"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
const _hoisted_5 = { class: "attachment-size" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-cloud-download" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_image_view = _resolveComponent("image-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["attachment-icon", $data.fileIcon == 'fa fa-image-o' ? 'has-img' : ''])
    }, [
      ($data.fileIcon != 'fa fa-image-o')
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass($data.fileIcon)
          }, null, 2))
        : (_openBlock(), _createBlock(_component_image_view, {
            key: 1,
            src: $props.path
          }, null, 8, ["src"]))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(_toDisplayString($props.fileName), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString($options.fileSize($props.size)), 1),
        _createElementVNode("a", {
          class: "pull-right",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.fileDownload && $options.fileDownload(...args))),
          style: {"margin-top":"-6px","font-size":"16px","color":"#666"}
        }, _hoisted_7)
      ])
    ])
  ]))
}